<script>
import AppNavigatorSection from './_AppNavigatorSection'

export default {
  name: 'AppNavigator',
  components: {
    AppNavigatorSection
  },
  props: {
    collapsed: { default: false, type: Boolean }
  },
  data() {
    return {
      showFavs: false,
      showSaves: false,
      showShares: false,
      showScheduled: false,
      categoriesReports: [],
      dashboards: []
    }
  },
  computed: {
    collapsedClass() {
      return {
        collapsed: this.collapsed
      }
    },
    sections() {
      let sections = [
        {
          label: 'Home',
          collapsedLabel: 'HOME',
          icon: 'home',
          //iconAdjust: 4,
          path: { name: 'Home' }
        }
      ]
      if (this.showFavs) {
        sections.push({
          label: 'Favorites',
          collapsedLabel: 'FAVS',
          icon: 'star',
          path: { name: 'Favorites' }
        })
      }
      if (this.showSaves) {
        sections.push({
          label: 'Saved Reports',
          collapsedLabel: 'SAVED',
          icon: 'save',
          path: { name: 'Saved' }
        })
      }
      if (this.showShares) {
        sections.push({
          label: 'Reports Shared With Me',
          collapsedLabel: 'SHARED',
          icon: 'share-alt',
          path: { name: 'Shared' }
        })
      }
      sections.push({
        label: 'Metrics Reports',
        collapsedLabel: 'REPORTS',
        icon: 'list',
        path: { name: 'Reports' },
        children: []
      })
      for (let category of this.categoriesReports) {
        sections.at(-1).children.push({
          label: category.label,
          path: {
            name: 'ReportCategory',
            params: { category: category.label }
          },
          alwaysVisible: true,
          children: category.reports.map(reportName => {
            return {
              label: reportName,
              //alwaysVisible: true,
              path: { name: 'Report', params: { name: reportName } }
            }
          })
        })
      }
      sections.push({
        label: 'Dashboards',
        collapsedLabel: 'DASHBOARDS',
        icon: 'chart-pie',
        path: { name: 'Dashboards' },
        children: []
      })
      for (let dashboard of this.dashboards) {
        sections.at(-1).children.push({
          label: dashboard,
          path: {
            name: 'Dashboard',
            params: { name: dashboard }
          },
          alwaysVisible: true
        })
      }
      if (this.showScheduled) {
        sections.push({
          label: 'Scheduled Reports',
          collapsedLabel: 'SCHEDULED',
          icon: 'calendar',
          path: {
            name: 'FormSearch',
            params: { formType: 'schedule' }
          }
        })
      }
      if (
        this.checkPermission({ app: 'metrics_dash', role: 'metrics_fy_users' })
      ) {
        sections.push({
          label: 'Fiscal Year Metrics',
          collapsedLabel: 'FY USERS',
          icon: 'users',
          path: { name: 'FYUserMenu' },
          children: [
            {
              label: 'Affiliation Types',
              path: {
                name: 'FormSearch',
                params: { formType: 'affiliationTypes' }
              }
            },
            {
              label: 'Approved / Excluded Projects',
              path: {
                name: 'FormSearch',
                params: { formType: 'fyUserMetricsDecisions' }
              }
            },
            {
              label: 'Finalize Fiscal Year Metrics',
              path: { name: 'FYUserFinalize' }
            },
            {
              label: 'Final User Metrics',
              path: {
                name: 'FormSearch',
                params: { formType: 'fyFinalMetrics' }
              }
            },
            {
              label: 'Ignored Project Titles',
              path: {
                name: 'FormSearch',
                params: { formType: 'ignoredProjectTitles' }
              }
            },
            {
              label: 'Manual User Projects',
              path: {
                name: 'FormSearch',
                params: { formType: 'fyUserMetricsManual' }
              }
            }
          ]
        })
      }
      if (
        this.checkPermission({ app: 'metrics_dash', role: 'metrics_qtr_data' })
      ) {
        sections.push({
          label: 'Quarter Completeness Data',
          collapsedLabel: 'COMPLETENESS',
          icon: 'clipboard-list',
          path: { name: 'QTRMenu' },
          children: [
            {
              label: 'Exceptions',
              path: {
                name: 'FormSearch',
                params: { formType: 'qtrMetricsExceptions' }
              }
            },
            {
              label: 'Filters',
              path: {
                name: 'FormSearch',
                params: { formType: 'qtrMetricsFilters' }
              }
            },
            {
              label: 'Modes',
              path: {
                name: 'FormSearch',
                params: { formType: 'qtrMetricsModes' }
              }
            }
          ]
        })
      }
      sections.push({
        label: 'Additional Dashboards',
        collapsedLabel: 'EXTRA',
        icon: 'external-link-alt',
        path: { name: 'AdditionalDashboards' }
      })
      return sections
    }
  },
  methods: {
    loadNavigationData() {
      this.graphql(
        /* GraphQL */ `
          query lookupOptions_MetricsMenu {
            allMetricsDashFavs {
              totalCount
            }
            saves: allMetricsDashSaves(
              filter: { sharedWithMe: { equalTo: false } }
            ) {
              totalCount
            }
            shares: allMetricsDashSaves(
              filter: { sharedWithMe: { equalTo: true } }
            ) {
              totalCount
            }
            schedules: allMetricsDashSchedules {
              totalCount
            }
            allMetricsDashBoards {
              nodes {
                dashboardName
              }
            }
            allMetricsDashReportCategories(orderBy: CATEGORY_NAME_ASC) {
              nodes {
                categoryName
                numReports
                metricsDashReportsByCategoryName(orderBy: REPORT_NAME_ASC) {
                  nodes {
                    reportName
                  }
                }
              }
            }
          }
        `
      ).then(data => {
        this.showFavs = data.allMetricsDashFavs.totalCount > 0
        this.showSaves = data.saves.totalCount > 0
        this.showShares = data.shares.totalCount > 0
        this.showScheduled = data.schedules.totalCount > 0
        this.categoriesReports = []
        for (let category of data.allMetricsDashReportCategories.nodes) {
          if (category.numReports) {
            this.categoriesReports.push({
              label: category.categoryName,
              reports: []
            })
            for (let report of category.metricsDashReportsByCategoryName
              .nodes) {
              this.categoriesReports.at(-1).reports.push(report.reportName)
            }
          }
        }
        this.dashboards = data.allMetricsDashBoards.nodes.map(
          node => node.dashboardName
        )
      })
    },
    toggle() {
      this.$emit('toggleCollapse')
    }
  },
  mounted() {
    this.loadNavigationData()
    this.$root.$on('refresh-nav', this.loadNavigationData)
  }
}
</script>

<template>
  <div id="AppNavigator" class="gContainer" :class="collapsedClass">
    <AppNavigatorSection
      v-for="section in sections"
      :key="section.label"
      :data="section"
      :collapsed="collapsed"
    />
    <div class="navigatorOptions">
      <div
        v-if="collapsed"
        class="expandIndicator"
        title="Expand Sidebar"
        @click="toggle"
      >
        <font-awesome-icon icon="expand-arrows-alt" />
      </div>
      <div v-else class="collapseIndicator" @click="toggle">
        <font-awesome-icon icon="compress-arrows-alt" />
      </div>
    </div>
  </div>
</template>

<style scoped>
#AppNavigator {
  height: 100%;
  box-sizing: border-box;
  border: 1px solid #000000;
  background-color: #0c2544;
  background: linear-gradient(90deg, #0b2544 0%, #194173 24.95%, #032548 100%);
}
#AppNavigator .navigatorOptions {
  color: #fff;
  height: 40px;
  width: 100%;
  line-height: 43px;
  font-size: 14pt;
  text-align: center;
  margin-top: 5px;
  text-align: right;
  padding-right: 10px;
}
#AppNavigator.collapsed {
  max-width: 64px;
}
#AppNavigator .collapseIndicator {
  position: absolute;
  bottom: 0;
  font-size: 16pt;
  text-align: right;
  background-color: #0c213a;
  width: 399px;
  padding-right: 10px;
  cursor: pointer;
}
#AppNavigator .expandIndicator {
  position: absolute;
  bottom: 0;
  font-size: 16pt;
  text-align: center;
  background-color: #0c213a;
  width: 63px;
  cursor: pointer;
}
.navigatorLink {
  color: #fff;
  height: 40px;
  width: 100%;
  line-height: 43px;
  font-size: 14pt;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  text-align: left;
  padding-right: 10px;
  margin-top: 5px;
}
.navigatorIcon {
  color: #fff;
  float: left;
  width: 32px;
  height: 32px;
  font-size: 32px;
  margin-left: 10px;
  margin-right: 20px;
  margin-top: 10px;
}
.iconAndLink {
  display: flex;
  flex-direction: row;
}
.iconAndLink:hover {
  background-color: #194173;
  cursor: pointer;
}
</style>
